import React from 'react';
import { instanceOf, bool } from 'prop-types';
import TCTreeItem from './TCTreeItem';

const TCTreeList = ({ tree, funcs, canDrag }) => {
  return (
    <div className="ie--tree--list">
      {tree.map((child, i) => (
        <TCTreeItem funcs={funcs} key={i} item={child} canDrag={canDrag} />
      ))}
    </div>
  );
};

TCTreeList.propTypes = {
  tree: instanceOf(Array).isRequired,
  funcs: instanceOf(Object).isRequired,
  canDrag: bool,
};

export default TCTreeList;
